// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-6a77d98d] .app-navigation-entry-icon{font-size:20px}`, "",{"version":3,"sources":["webpack://./src/components/Nav/CollectiveListItem.vue"],"names":[],"mappings":"AACA,6CACC,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
